export default __webpack_public_path__ + "static/media/Dr._Anino_Emuwa_AHV_In_Moms_We_Trust.0c466aee.jpg";